import PropTypes from 'prop-types'
import React from 'react'

function formatTimeNumber(timeNumber) {
  let formattedTimeNumber = Math.floor(timeNumber).toFixed(0)
  if (formattedTimeNumber.length < 2) {
    formattedTimeNumber = `0${formattedTimeNumber}`
  }

  return formattedTimeNumber
}

function formatTime(timeInSeconds) {
  if (
    timeInSeconds === undefined ||
    timeInSeconds === null ||
    timeInSeconds === Infinity
  ) {
    return '--:--'
  }

  const minutes = Math.floor(timeInSeconds / 60)
  const seconds = timeInSeconds % 60

  return `${formatTimeNumber(minutes)}:${formatTimeNumber(seconds)}`
}

export default function Timer(props) {
  const { duration, position } = props

  const timer = [position, duration].filter(
    (val) => val !== undefined && val !== null && val !== Infinity,
  )

  return <span>{timer.map(formatTime).join(' / ')}</span>
}

Timer.propTypes = {
  duration: PropTypes.number,
  position: PropTypes.number,
}
